import { create } from 'zustand';

import type { FirebaseUser } from '@/lib/firebase';

type AuthState = {
  firebaseUser: FirebaseUser | null;
  isAdmin: boolean;
  isLoading: boolean;
  setFirebaseUser: (user: FirebaseUser | null) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  reset: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  firebaseUser: null,
  isAdmin: false,
  isLoading: true,
  setFirebaseUser: (user) => set({ firebaseUser: user }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  setIsLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ firebaseUser: null, isAdmin: false, isLoading: false }),
}));
